import React, { useEffect } from 'react';
import T from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, Typography } from '@mui/material';
import { NotifyTypo } from 'web-components';

import { COLOR_PRIMARY } from 'attrs/colors';
import { getInitials } from 'helpers/utils';
import { loadOrganization } from '../../../redux/user/actions';
import { ProfileWrapper } from './elements';
import withLoadingState from '../../../helpers/withLoadingState';
import { getOrganization } from '../../../redux/user/selectors';

const OrganizationProfile = ({ organization }) => (
  <>
    <NotifyTypo.Heading2>{organization.name}</NotifyTypo.Heading2>
    <Avatar
      alt={organization.name}
      src={organization.logo}
      sx={{
        ml: 1,
        width: 56,
        height: 56,
        flexShrink: 0,
        borderRadius: '50%',

        '& .MuiAvatar-img': {
          objectFit: 'cover'
        },

        ...(!organization.logo && {
          bgcolor: COLOR_PRIMARY,
          color: '#FFFFFF',
          fontSize: 14
        })
      }}
    >
      <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{getInitials(organization.name)}</Typography>
    </Avatar>
  </>
);

OrganizationProfile.propTypes = {
  organization: T.shape({ name: T.string, logo: T.string }).isRequired
};

const OrganizationProfileWithLoadingState = withLoadingState(OrganizationProfile);

const ConnectedOrganizationProfile = () => {
  const dispatch = useDispatch();
  const { loadingState, data } = useSelector(getOrganization);

  useEffect(() => {
    dispatch(loadOrganization());
  }, [dispatch]);

  return (
    <ProfileWrapper>
      <OrganizationProfileWithLoadingState
        loadingState={loadingState}
        reloadAction={() => dispatch(loadOrganization())}
        organization={data}
      />
    </ProfileWrapper>
  );
};

export default ConnectedOrganizationProfile;
